import { isApiValidationError } from '@/types/api/apiErrorTypes';
import { set, merge } from '@/utils/libs/lodash';
/** 値をSubmit用のバリデーションエラーオブジェクトにして返す */
export const apiValidationExceptionToSubmissionErrors = (exception) => {
    // バリデーションエラーの例外でない場合
    if (!isApiValidationError(exception)) {
        return undefined;
    }
    // バリデーションエラーメッセージを取得
    const { response: { data: { data: { messages }, }, }, } = exception;
    const errorMessages = Object.keys(messages);
    if (!errorMessages.length) {
        return undefined;
    }
    // { [フィールド名]: 'エラーメッセージ' } の形で返す
    return errorMessages.reduce((result, key) => {
        const newObject = set({}, key, messages[key][0] || '');
        return merge(result, newObject);
    }, {});
};
